// extracted by mini-css-extract-plugin
module.exports = {"root":"ThankYou-root-1oBS5","title":"ThankYou-title-3IHg8","dismiss":"ThankYou-dismiss-YFPf5"};